export function requiredFieldAvailableWorkFlowRoles(data, state) {
  const { roles, workFlowType } = state.WorkFlowRolesReducer.data;
  const selectedRoles = data;
  if (roles.length === 0)
    return true;
  return selectedRoles.filter(rle => rle.workFlowType === workFlowType)?.length > 0;
}
